import { theme } from '@theme';
import styled from 'styled-components';

type SupportTooltipWrapperProps = {
  isMobileDevice?: boolean;
};

type SupportContentWrapperProps = {
  isMobileDevice?: boolean;
};

type SupportOrWrapperProps = {
  isMobileDevice?: boolean;
};
type IconProps = {
  fontSize?: number;
  type?: string;
};

export const SupportHelpWrapper = styled.div``;

export const SupportTooltipWrapper = styled.div<SupportTooltipWrapperProps>`
  background-color: ${theme.palette.white};
  ${(props) =>
    !props.isMobileDevice
      ? `position: absolute;
     right: 15px; width: 600px; top: 100%; margin-top: 5px;
     border: 1px solid ${theme.palette.disabledGrey};
     box-shadow: 0 1px 9px -3px rgba(0, 0, 0, 0.4);
     max-width: 600px;`
      : ''};
`;
export const SupportHeader = styled.div`
  background-color: ${theme.palette.basicGrayTwo};
  height: 75px;
  line-height: 75px;
  border-bottom: 1px solid ${theme.palette.lightGrayFive};
  text-align: center;
  text-transform: uppercase;
  font-size: ${theme.typography.fontSize20}px;
  font-weight: ${theme.typography.fontWeights.semibold};
  letter-spacing: 1px;
  color: ${theme.palette.basicGray};
  position: relative;
  border-radius: 6px 6px 0 0;
  &:after,
  &:before {
    bottom: 100%;
    right: 20px;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  &:after {
    border-color: transparent;
    border-bottom-color: ${theme.palette.basicGrayTwo};
    border-width: 13px;
    margin-left: -13px;
  }

  &:before {
    border-color: transparent;
    border-bottom-color: ${theme.palette.lightGrayFive};
    border-width: 14px;
    margin-left: -14px;
  }
`;

export const SupportCloseWrapper = styled.div`
  position: absolute;
  right: 0;
  color: ${theme.palette.lightGrayFour};
  font-weight: ${theme.typography.fontWeights.semibold};
  font-size: ${theme.typography.fontSize16}px;
  top: 5px;
  line-height: 40px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  &:hover {
    color: ${theme.palette.darkGrey};
  }
`;

export const SupportContentWrapper = styled.div``;

export const SupportContentText = styled.h5<SupportContentWrapperProps>`
  margin: 0;
  padding-top: 20px;
  text-align: center;
  color: ${(props) =>
    props.isMobileDevice ? theme.palette.wetAsphalt : theme.palette.darkGreyTwo};
  margin-bottom: 10px;
  font-weight: ${theme.typography.fontWeights.semibold};
  font-size: ${(props) => (props.isMobileDevice ? ' x-large' : theme.typography.fontSize16 + 'px')};
  &:first-child {
    padding-top: 30px;
  }
`;

export const SupportNumberWrapper = styled.div`
  text-align: center;
  color: ${theme.palette.borderPurple};
  font-size: ${theme.typography.fontSize20}px;
  font-weight: ${theme.typography.fontWeights.semibold};
  letter-spacing: 1px;
  margin-top: 10px;
  line-height: 28px;
`;

export const MobileSupportNumber = styled.a`
  text-decoration: underline !important;
  text-align: center;
  color: ${theme.palette.borderPurple};
  font-size: ${theme.typography.fontSize20}px;
  font-weight: ${theme.typography.fontWeights.semibold};
  letter-spacing: 1px;
  margin-top: 10px;
  line-height: 28px;
`;
export const SupportOrWrapper = styled.div<SupportOrWrapperProps>`
  position: relative;
  margin-left: ${(props) => (props.isMobileDevice ? '25' : '40')}px;
  margin-right: ${(props) => (props.isMobileDevice ? '25' : '40')}px;
  margin-top: 20px;
  height: 40px;
  &:before {
    content: '';
    height: 1px;
    width: 100%;
    display: block;
    background-color: ${theme.palette.background};
    position: absolute;
    top: 50%;
  }
`;

export const SupportOrSpan = styled.span`
  display: block;
  width: 60px;
  height: 40px;
  position: absolute;
  left: calc(50% - 30px);
  background-color: ${theme.palette.white};
  color: ${theme.palette.white};
  text-align: center;
  padding-top: 5px;
  &:before {
    content: 'or';
    background-color: ${theme.palette.darkGrayThree};
    display: inline-block;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    text-align: center;
    line-height: 30px;
    font-size: ${theme.typography.fontSize16}px;
    font-weight: ${theme.typography.fontWeights.semibold};
  }
`;

export const IconWrapper = styled.i.attrs<IconProps>((props) => ({
  className: `am-icon am-icon-${props.type}`,
}))<IconProps>`
  font-size: ${(props) => props.fontSize}%;
`;
